<template>
  <div class="home" style="margin: 8px 0;">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-12 is-three-quarters-tablet is-two-thirds-desktop has-text-left">
          <img class="app-icon" :src="header_src">

          <h2 class="title is-marginless has-text-centered">「春のポッドキャストまつり」参加番組一覧</h2>
          <div class="sub-title is-6 has-text-right">
            ※ランダム順に表示されます
            <ul class="share-buttons">
              <li>
                <a
                  href="https://twitter.com/intent/tweet?source=https%3A%2F%2Fpodcast-festival.firebaseapp.com%2F&text=%23%E6%98%A5%E3%81%AE%E3%83%9D%E3%83%83%E3%83%89%E3%82%AD%E3%83%A3%E3%82%B9%E3%83%88%E3%81%BE%E3%81%A4%E3%82%8A%20https%3A%2F%2Fpodcast-festival.firebaseapp.com%2F"
                  target="_blank"
                  title="Tweet"
                >
                  <img alt="Tweet" src="Twitter.svg">
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fpodcast-festival.firebaseapp.com%2F&quote=%23%E6%98%A5%E3%81%AE%E3%83%9D%E3%83%83%E3%83%89%E3%82%AD%E3%83%A3%E3%82%B9%E3%83%88%E3%81%BE%E3%81%A4%E3%82%8A"
                  title="Share on Facebook"
                  target="_blank"
                >
                  <img alt="Share on Facebook" src="Facebook.svg">
                </a>
              </li>
            </ul>
          </div>
          <div style="display: flex; justify-content: center; margin: 0 0 8px 0;">
            <div class="tags has-addons">
              <span class="tag is-warning is-medium">現在の参加番組数</span>
              <span class="tag is-danger is-medium">
                <channelcount></channelcount>
              </span>
            </div>
          </div>

          <div class="desc">
            <h4>ポッドキャストって？</h4>
            <VueFoldable class="my-foldable" height="20">
              <!-- named slot -->
              <p
                align="center"
                class="my-foldable"
                slot="view-more"
                slot-scope="{ toggle, collapsed }"
                @click="toggle"
              >
                <span class="expand-button">{{ collapsed ? '▼続きを読む▼' : '▲閉じる▲' }}</span>
              </p>
              <p>
                ポッドキャスト(podcast)は、無料で聴けるインターネットラジオです。
                ※iPhoneに入っているコレでも聴けます→
                <img
                  class="app-icon"
                  :src="podicon_src"
                >
              </p>
              <p>ポッドキャストアプリでお気に入りの番組を「登録／購読」しておくと、更新されるたびに通知が届きます。</p>
              <p>電波のラジオとは異なり、ダウンロードして好きな時に聴くことが出来ます。</p>
            </VueFoldable>
            <h4>ポッドキャストのメリット</h4>
            <VueFoldable>
              <p
                align="center"
                class="my-foldable"
                slot="view-more"
                slot-scope="{ toggle, collapsed }"
                @click="toggle"
              >
                <span class="expand-button">{{ collapsed ? '▼続きを読む▼' : '▲閉じる▲' }}</span>
              </p>
              <p>視覚を奪われないので、何かをしながらマルチタスクでインプットが出来るのが大きなメリット。</p>
              <p>通勤途中に歩きながら、英会話やニュースなどを継続して聴くことが出来ます。一日30分聴くとすると、年間で120時間もの「学ぶ」「楽しむ」時間を捻出することが出来ちゃうんです。</p>​
            </VueFoldable>
            <h4>ポッドキャストの聴き方</h4>
            <VueFoldable>
              <p
                align="center"
                class="my-foldable"
                slot="view-more"
                slot-scope="{ toggle, collapsed }"
                @click="toggle"
              >
                <span class="expand-button">{{ collapsed ? '▼続きを読む▼' : '▲閉じる▲' }}</span>
              </p>
              <div class="content">
                <ul>
                  <li>各番組タイトル（もしくはアイコン画像）をクリック／タップ</li>
                  <li>番組のWebサイトが開きます</li>
                  <li>多くの場合、そのページ内で音声を聴くことが出来ます</li>
                  <li>ポッドキャストアプリで購読（無料です）しておくと配信の際に自動で通知されて便利です</li>
                </ul>
              </div>
            </VueFoldable>
            <h4>春のポッドキャストまつり</h4>
            <VueFoldable>
              <p
                align="center"
                class="my-foldable"
                slot="view-more"
                slot-scope="{ toggle, collapsed }"
                @click="toggle"
              >
                <span class="expand-button">{{ collapsed ? '▼続きを読む▼' : '▲閉じる▲' }}</span>
              </p>
              <p>
                そんな便利なポッドキャストを、より多くの方に使って頂けたらと思い、番組を配信しているポッドキャスターが集まりました。
                ビジネス・心理学・プログラミング・キャリア…とジャンルは多岐にわたっています。
              </p>
              <p>
                今回、「春のポッドキャストまつり」と題して、期間中(2019/03/29[金]～4/11[木])は各番組内で、新社会人の皆さんに向けて「頑張って！」「これだけは知っといたほうがいいっ」「気疲れした時には…」などなどエールを送っています
                <span
                  class="icon has-text-danger"
                >
                  <i class="fas fa-heart"></i>
                </span>
              </p>
              <p>就職のために引っ越した人。一人で都会に出てきて心細い人。慣れない環境で不安な人。いろいろな環境の方がいらっしゃると思います。</p>
              <p>でも、たくさんの人が応援してくれていること、忘れないでいてくれたら嬉しいです。</p>
              <p>何かつらいことや悩みゴトが出てきたら、気軽に番組配信者の方に Twitter で相談してみてください。きっと優しく答えてくれると思いますょ。</p>
            </VueFoldable>
          </div>
        </div>
      </div>
    </div>
    <channels></channels>
    <p>&nbsp;</p>
    <div class="footer has-background-warning">
      <div class="content has-text-centered is-size-6">
        <span class='has-text-weight-bold'>春のポッドキャストまつり2019</span>
        <br>本企画に関するお問い合わせ先：
        <a href="https://twitter.com/goodengineer7">S(エス) Twitter</a>
      </div>
    </div>
  </div>
</template>

<script>
import VueFoldable from "vue-foldable";
import channels from "@/components/Channels";
import channelcount from "@/components/ChannelCount";

export default {
  name: "home",
  components: {
    channels,
    channelcount,
    VueFoldable
  },
  data() {
    return {
      header_src: require("@/assets/FSE_PodcastFestival_LP_Head.jpg"),
      podicon_src: require("@/assets/Apple_Podcast_Icon.png")
    };
  },
  created: function() {},
  computed: {},
  methods: {}
};
</script>
<style>
@import "../../node_modules/vue-foldable/dist/vue-foldable.css";

.desc p {
  line-height: 1.4em;
  padding-bottom: 0.6em;
}
.desc p img.app-icon {
  display: inline-block;
  vertical-align: middle;
}
.desc h4 {
  font-size: 118%;
  font-weight: bold;
  background-color: #c9fdd6;
  padding: 2px 8px 2px 8px;
  margin-bottom: 6px;
  border-radius: 4px;
}

.expand-button {
  font-size: small;
  background-color: #fffa57;
  padding: 4px 8px 4px 8px;
  margin: 4px;
  border-radius: 4px;
  cursor: pointer;
}

/* use stylus -> css converter */
.vue-foldable.my-foldable .vue-foldable-mask {
  /* tweak the mask's postion according to your view more's   t */
  bottom: 33px;
}
</style>